import React from 'react';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useRegisterWebPush } from './WebPushHandler';

// The priming dialog shown before the browser's own permission prompt.
type NotificationsPromptProps = {
  shouldPrompt: boolean;
  toggle: () => void;
};

export const NotificationsPrompt: React.FC<NotificationsPromptProps> = ({
  shouldPrompt,
  toggle,
}) => {
  const registerWebPush = useRegisterWebPush();
  const [loading, setLoading] = React.useState(false);

  if (!shouldPrompt) {
    return null;
  }
  return (
    <AlertDialog open={shouldPrompt} onOpenChange={toggle}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Recibí notificaciones</AlertDialogTitle>
          <AlertDialogDescription>
            Para recibir notificaciones y recordatorios relacionados a tus
            proyectos en este dispositivo, presiona en Aceptar, y acepta los
            permisos requeridos en la próxima pantalla.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cerrar</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              setLoading(true);
              registerWebPush().finally(() => {
                setLoading(false);
                toggle();
              });
            }}
            disabled={loading}
          >
            {loading ? <LoadingSpinner /> : 'Aceptar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
